import { useState } from 'react';
import { useSelector } from 'react-redux';

export const useFields = (codeTier) => {

    const { tiers } = useSelector(state => state.tier);
    const [advancedFields] = useState(tiers['advanced']?.fields || [])

    return {
        advancedFields
    }
}